/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourceResponseSchema = z.object({
  active: z.boolean(),
  anonymized: z.boolean(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  email: z.string().nullish(),
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND']),
  id: z.int(),
  instanceId: z.string().nullish(),
  name: z.string(),
  oauthCredentialsId: z.int().nullish(),
  organizationId: z.string(),
  sourceId: z.string().nullish(),
  status: z.enum(['ACTIVE', 'DEACTIVATED']),
  type: z.enum(['RESOURCE', 'PLACEHOLDER']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
  workforceCategory: z.enum(['EMPLOYEE', 'CONTRACTOR', 'VENDOR', 'FREELANCER']),
});
